import { Link } from 'react-router-dom';
import { RoutePaths } from 'routes/route-paths';

function TermsContent({ path }: { path?: string }) {
  return (
    <div className="mx-4">
      <h2 className="font-bold">INTRODUCTION</h2>
      <p className="mb-8 text-justify">
        JompStart is a product of JompStart Digital Limited, a limited liability
        company registered in the Federal Republic of Nigeria.
      </p>

      <p className="mb-8 text-justify">
        JompStart (or Jomp) is a service aggregation platform / marketplace
        where individuals and households are able to easily find and
        conveniently pay for life’s essential services such as school fees,
        house rent, transportation, medical care, auto care, home repairs,
        grooming and wellness etc., in affordable monthly installments.
      </p>
      <p className="mb-8 text-justify">
        JompStart connects providers of these essential services with
        individuals who need the services, without both parties being burdened
        about the immediate payment for the services. By offering flexible
        payment plans, transparent terms, and a user-friendly platform that
        helps our users to easily find the best and most affordable essential
        services they truly need, JompStart removes the stress associated with
        these life events and addresses the financial burden of these large and
        sometimes unexpected expenses, promoting financial wellness, stability,
        growth and peace of mind.
      </p>
      <p className="mb-8 text-justify">
        In these Terms and Conditions (T&Cs), “We”, “Us”, “Our” and their
        variants in these T&Cs refer to JompStart. “You”, “Your”, and their
        variants refer to users of our platform, either the Service Provider or
        the User of such services.
      </p>

      <h4 className="font-bold">TERMS AND CONDITIONS</h4>
      <ol>
        <ol type="1" className="list-decimal ml-4 space-y-4">
          <li className="font-semibold mb-3">USER</li>
          <ol type="a" className="font-bold list-[lower-alpha] space-y-4 ml-4">
            <li>Onboarding</li>
            <ol
              type="i"
              className="font-normal space-y-2 marker:font-bold list-[lower-roman] ml-4"
            >
              <li>
                As a User on the platform who intends to access and pay for
                life’s essential services, you are required to create an account
                on
                <a
                  href="https://www.jompstart.com/"
                  target="_blank"
                  className="text-blue-500"
                >
                  {' '}
                  www.jompstart.com{' '}
                </a>
                or our mobile application.
              </li>
              <li>
                To create an account, you will be required to provide the
                following details:
                <ol type="A" className="list-[upper-alpha] ml-4">
                  <li>Email Address</li>
                  <li>A unique password</li>
                </ol>
              </li>
              <li>
                After creation of account and verification of your email
                address, you are required to provide the following details to
                complete the creation of your Jomp account:
                <ul>
                  <li>
                    <strong>A.</strong> Name
                  </li>
                  <li>
                    <strong>B.</strong> Contact Address
                  </li>
                  <li>
                    <strong>C.</strong> Phone Number
                  </li>
                  <li>
                    <strong>D.</strong> Date of Birth
                  </li>
                  <li>
                    <strong>E.</strong> Debit card details, National
                    Identification Number (NIN), and Bank Verification Number
                    (BVN). These are required for the payment/lending/financial
                    goals options on our platform. Please note that we do not
                    store your card details.
                  </li>
                </ul>
              </li>

              <li>
                You may also sign up on our platform using your social media
                accounts, such as Google, Facebook, Apple, or LinkedIn.
              </li>
            </ol>
            <li> Accessing Essential Service</li>
            <ol
              type="i"
              className="font-normal space-y-2 marker:font-bold list-[lower-roman] ml-4"
            >
              <li>
                There are two options for you to access an essential service on
                our platform:
              </li>
              <ol type="A" className="list-[upper-alpha] ml-4">
                <li>
                  You can access a service through Jomp Curated Services. Jomp
                  Curated Services are essential services that are available on
                  the Jomp platform and users can access and pay for them on
                  JompStart.
                </li>
                <li>
                  <strong> User Created Services.</strong> User Created Services
                  are services that a user has accessed either offline or
                  outside of Jomp but wishes to pay for such using PayLater with
                  Jomp.
                </li>
              </ol>
              <li>
                JompStart is only an aggregator of these services. JompStart
                does not guarantee that a service will be fit for a particular
                purpose or will meet certain standards of quality.
              </li>
              <li className="mb-4">
                JompStart shall not bear responsibility whatsoever for any poor
                quality of service rendered by a Service Provider either
                accessed through Jomp Curated Service option or User Created
                Service feature.
              </li>
              <li className="mb-4">
                JompStart may seek feedback from Users on the quality of service
                rendered by Service Providers on the platform in order to ensure
                only Service Providers of the highest quality are available on
                the platform.
              </li>
              <li className="mb-4">
                v.When this option is available, a User, in agreement with a
                Service Provider, may require that JompStart holds a certain
                portion of an amount to be paid to the Service Provider by the
                User till completion of the service. JompStart shall hold the
                amount in trust for both parties and either return the money to
                the User or pays the Service Provider on the verifiable
                completion of the Service.
              </li>
              <li className="mb-4">
                vi.A User may pay for a Service on JompStart by paying one-time,
                or through a recurring payment, or by using Pay Later with Jomp.
              </li>
            </ol>
            <li>Pay Later with Jomp</li>
            <ol
              type="i"
              className="font-normal space-y-2 marker:font-bold list-[lower-roman] ml-4"
            >
              <li className="mb-b">
                Where you are unable to pay in full at once for a Jomp Curated
                Service or a User Created Service, you can choose to Pay Later
                with Jomp.
              </li>
              <li className="mb-4">
                With Pay Later with Jomp, Jomp can pay in full upfront for the
                Service on your behalf while you pay back to Jomp in convenient
                monthly installments. Jomp may also pay the Service Provider in
                monthly installments on your behalf, subject to an agreement
                with the Provider.
              </li>
              <li className="mb-4">
                Subject to change,{' '}
                <strong>
                  Pay Later with Jomp attracts a monthly interest of 6% on a
                  reducing balance basis.
                </strong>
              </li>
              <li className="mb-4">
                To be qualified for Pay Later with Jomp, JompStart may require
                more personal information from you in order to determine your
                eligibility. These personal information may include:
                <ol type="A" className="list-[upper-alpha] ml-4">
                  <li className="mb-4">
                    A.Your employment details – employment ID, employer’s
                    information, official email address, salary payment slips
                  </li>

                  <li className="mb-4">
                    B.Other personal information - recent utility bill,
                    government issued ID, passport photographs, etc.
                  </li>
                  <li className="mb-4">Bank accounts statements</li>
                  <li className="mb-4">
                    For school fees service, basic personal information about
                    your children, information about the school(s) they attend,
                    and payment invoice from the school fees
                  </li>
                  <li className="mb-4">
                    E.For house rent, your tenancy agreement or rent offer, and
                    your landlord’s details
                  </li>
                  <li className="mb-4">
                    For healthcare service, information about your healthcare
                    needs, the medical bill, the medical facility and personnel
                    in charge of your care, where necessary, etc.
                  </li>
                  <li className="mb-4">
                    Other relevant personal and non-personal information,
                    subject to the nature of the service you wish to pay for
                    through Pay Later with Jomp.
                  </li>
                </ol>
              </li>
              <li className="mb-4">
                You grant us express consent to process these personal
                information, including the basic personal information of your
                children, in accordance with relevant privacy and data
                protection laws. To know more about how we collect, process, and
                store personal information, please read our{' '}
                <Link
                  to={path ? path : RoutePaths.PRIVACY}
                  className="text-blue-400"
                >
                  Privacy Notice.
                </Link>
              </li>
              <li className="mb-4">
                Please note that where you use Pay Later with Jomp to pay for a
                service, the poor quality of service, the lack of service, or
                other similar issues, do not remove or extinguish your repayment
                obligation to JompStart.
              </li>
              <li className="mb-4">
                For the lack of service, JompStart may assist in either ensuring
                that you receive the service or recover the service fee. This,
                however, does not place any obligation on JompStart and such
                effort by JompStart is based on convenience and does not remove
                the obligation of repayment from the User.
              </li>
            </ol>
          </ol>

          {/* service provider */}
          <li className="font-semibold mb-3">SERVICE PROVIDER</li>
          <ol type="a" className="font-bold list-[lower-alpha] space-y-4 ml-4">
            <li>Onboarding</li>
            <ol
              type="i"
              className="font-normal space-y-2 marker:font-bold list-[lower-roman] ml-4"
            >
              <li className="mb-4">
                As a Service Provider who intends to make available some of
                life’s essential services on JompStart to Users, you are
                required to create a Service Provider account on
                <a
                  className="text-blue-400"
                  href="https://www.jompstart.com/"
                  rel="noreferrer"
                  target="_blank"
                >
                  {' '}
                  www.jompstart.com.{' '}
                </a>
              </li>
              <li className="mb-4">
                To create an account, you will be required to provide the
                following details:
                <ol type="A" className="list-[upper-alpha] ml-4">
                  <li> Business Email Address </li>
                  <li> A unique password </li>
                </ol>
              </li>
              <li className="mb-4">
                After creation of account and verification of your email
                address, you are required to provide the following details to
                complete the creation of your Jomp account:
                <ol type="A" className="list-[upper-alpha] ml-4">
                  <li>
                    Your business information, such as business type, name of
                    your business, business registration number, and your
                    business registration documents. If your business is not
                    registered, you can select “Starter / Unregistered Business”
                    and provide the required information.
                  </li>
                  <li className="mb-4">
                    Business Owner’s Information, such as your full name,
                    contact address, National Identification Number (NIN), phone
                    number, email address.
                  </li>
                  <li className="mb-4">Business Bank Information.</li>
                </ol>
              </li>
            </ol>

            {/* provide essentaial services  */}
            <li>Providing Essential Service</li>
            <ol
              type="i"
              className="font-normal space-y-2 marker:font-bold list-[lower-roman] ml-4"
            >
              <li className="mb-4">
                There are two options for you, as a Service Provider, to provide
                an essential service on our platform:
              </li>

              <ol type="A" className="list-[upper-alpha] ml-4">
                <li className="mb-4">
                  You can provide the service through a store front on
                  JompStart. With this, Users can access your service page on
                  JompStart and pay for your service.
                </li>
                <li className="mb-4">
                  Through a service link. You can create a service link on
                  JompStart to share with your users who are not on JompStart.
                  Your users who are not on Jomp can use your service link for
                  three options:
                  <ol type="I" className="list-[upper-roman] ml-4">
                    <li className="mb-4">
                      To access your service on JompStart and pay in full at
                      once with Pay with Jomp
                    </li>
                    <li className="mb-4">
                      To access your service either on JompStart or offline and
                      make recurring payments to you on Jomp.
                    </li>
                    <li className="mb-4">
                      To access your service either on Jomp or offline but Pay
                      Later with Jomp.
                    </li>
                  </ol>
                </li>
              </ol>
              <li className="mb-4">
                For every service that you provide and is paid for on JompStart,
                JompStart shall charge you a Sales Commission. The percentage of
                this Sales Commission shall be communicated to you before such
                service is consummated between you and the User.
              </li>
              <li className="mb-4">
                JompStart does not serve as a guarantor for your service.
                JompStart reserves the right to suspend, deactivate, delist, and
                remove your account on JompStart where you do not abide by the
                Terms and Conditions of operating an account on Jomp or there is
                persistent negative feedback about your quality of service.
              </li>
              <li className="mb-4">
                Where a User lodges a complaint with JompStart about non-receipt
                of a service that has been paid for, JompStart shall conduct an
                inquiry into such a complaint. Where the complaint is genuine,
                JompStart shall require you to either render the service as paid
                for, or refund the User.
              </li>
            </ol>

            {/* pay later with jump  */}
            <li className="mb-4">Pay Later with Jomp</li>
            <ol
              type="i"
              className="font-normal space-y-2 marker:font-bold list-[lower-roman] ml-4"
            >
              <li>
                Where a User is unable to pay in full at once for your service
                either accessed on JompStart, through a service link, or
                offline, such User can choose to Pay Later with Jomp.
              </li>
              <li className="mb-4">
                With Pay Later with Jomp, Jomp may either pay you in full
                upfront for the Service on behalf of the User, or Jomp may pay
                you in monthly installments, subject to agreement between us and
                you.
              </li>
              <li className="mb-4">
                Where you are paid in full upfront or in monthly installments,
                you are obligated to provide the service as agreed with the
                User.
              </li>
              <li className="mb-4">
                Jomp may assist the User to recover the fee for a service that
                is not rendered as and when due.
              </li>
            </ol>
          </ol>

          {/* recovery loans  */}
          <li className="mb-4 font-semibold ">RECOVERY OF LOANS</li>
          <ol
            type="a"
            className="font-normal space-y-2 marker:font-bold list-[lower-alpha] ml-4"
          >
            <li className="mb-4">
              Where you use Pay Later with Jomp to make a payment on JompStart,
              please note that the loan may be provided by our banking /
              financing partner on the JompStart platform.
            </li>
            <li className="mb-4">
              Where required, you may also have to sign or accept the offer
              letter of our banking partner on the JompStart platform.
            </li>
            <li className="mb-4">
              You agree and consent that we may share your relevant personal
              data with partners like credit bureaus and our banking partner for
              your credit assessment, recovery of the loan, and other purposes
              connected with this Terms and Conditions.
            </li>
            <li className="mb-4">
              You agree that{' '}
              <strong>
                a late payment penalty of 0.5% flat per day shall apply to any
                unpaid part of your loan{' '}
              </strong>{' '}
              after each due date, till the repayment is done.
            </li>
            <li className="mb-4">
              Notwithstanding a contrary provision of this Terms and Conditions,
              you agree that we have the right to use every legal means,
              including but not limited to an action in law and equity to
              recover the loan amount with interest if you default in the
              repayment as and when due.
            </li>
            <li className="mb-4">
              You give a right of set-off to us and/or our banking partner from
              your wallet with us or any account you maintain with any bank for
              any loan due. You also agree and consent that our banking partner
              may approach other financial institutions to settle your
              obligations to us from your bank account(s) held with such
              financial institutions.
            </li>
            <li className="mb-4">
              You agree and you are obliged to indemnify us and our banking
              partner and keep us indemnified against any cost and expenses
              suffered and incurred by us and our banking partner (including but
              not limited to legal fees) arising out of your failure to perform
              your loan obligations.
            </li>
            <li className="mb-4">
              You agree that either us or our banking partner, or both of us
              acting together, shall have the right to seek legal redress to
              recover the loan amount and any associated cost in the event of
              your default and you shall not raise any objection to this.
            </li>
          </ol>

          {/* save with jomp  */}
          <li className="mb-4 font-semibold ">SAVE WITH JOMP</li>

          <ol
            type="a"
            className="font-normal space-y-2 marker:font-bold list-[lower-alpha] ml-4"
          >
            <li className="mb-4">
              “Save with Jomp” is our savings product powered and managed by our
              licensed banking and financial partners. With Save with Jomp, you
              can save for your essential services and withdraw your savings at
              your pre-set maturity date.
            </li>
            <li className="mb-4">
              You have to be registered as a user on JompStart to use our
              savings feature.
            </li>
            <li className="mb-4">
              There are different types of savings under Save with Jomp –
              JompVault, JompReserve, and JompFortress. Currently, only
              JompVault is available. We will launch the others in due time.
            </li>

            <li className="mb-4">
              With our JompVault, users are required to save toward a particular
              goal. You will input the name of the savings, your savings goal,
              the duration of the savings, and whether you want to save daily,
              weekly, or monthly. Your savings will earn a pre-defined interest
              every day which you would see on your savings dashboard.
            </li>
            <li className="mb-4">
              After you supply the above information, our system will suggest to
              you how much you should be saving per time. However, you are at
              liberty to choose or input a different amount. Please note that if
              the amount you choose cannot meet up with your Savings Goal, our
              system will change the Savings Goal. You can choose to proceed
              with our changed amount or go back and change the goal to your
              desired amount.
            </li>
            <li className="mb-4">
              You are also required to choose whether you want your savings to
              be automatically deducted from your Jomp Wallet or from your debit
              card, our two available sources of funding your savings. Please
              note that we do not store your card details. If you desire to
              auto-save, you would also choose the time that the auto debit
              would happen on your wallet or card.
            </li>
            <li className="mb-4">
              Further, you can also choose if you want your savings to be paid
              automatically into your Wallet upon maturity or not. If you do not
              choose auto-withdrawal, your savings will go into “Rolled-Over”
              upon maturity and will continue to earn interest, but at a lesser
              percentage compared to your Savings Goal.
            </li>
            <li className="mb-4">
              You can leave your saved amount in the Rolled-Over for as long as
              you want or use it to initiate another savings goal, or you can
              withdraw it into your Wallet.
            </li>
            <li className="mb-4">
              After creating your savings, you can view the details of the
              savings under “Ongoing”. After your maturity date, your savings
              will move to “Completed” if it is set to auto-withdraw and your
              funds will be available in your Jomp Wallet.
            </li>

            <li className="mb-4">
              Whether you activated the auto-save option or not, you can also
              credit your savings by yourself. You can use the “Credit Savings”
              or “Top-Up” option under “Ongoing” on your savings dashboard.
            </li>
            <li className="mb-4">
              Please note that you can withdraw from your Savings at any time
              before maturity. However, you would lose a certain percentage of
              the interest you have earned so far any time you withdraw from
              your savings goal before your maturity date.
            </li>
            <li className="mb-4">
              Also, at your maturity date, if you do not achieve your Savings
              Goal, you would lose a certain percentage of the interest you have
              earned on the Savings Goal. Our policy is geared toward
              encouraging financial discipline while accommodating flexibility
              in the event “life happens.”
            </li>
            <li className="mb-4">
              We do not keep the funds you save with us. Our customers’ funds
              are managed by our licensed banking and financial partners who
              have the licence to keep such funds with the appropriate insurance
              protection for such funds. Although, we are generally liable to
              you for any funds you save with us.
            </li>
            <li className="mb-4">
              Our interest rate is dependent on market realities and our
              partners. We reserve the right to review the interest rate without
              prior notice to you. But you will see the applicable interest per
              time on our platform.
            </li>
          </ol>

          {/* How to delete your jompstart account  */}
          <li className="mb-4 font-semibold  uppercase">
            How to delete your jompstart account
          </li>

          <ol
            type="a"
            className="font-normal space-y-2 marker:font-bold list-[lower-alpha] ml-4"
          >
            <li className="mb-4">
              You have the right to permanently delete your account on JompStart
              whenever you need to
            </li>
            <li className="mb-4">
              However, because JompStart is a financial app, we need to ensure
              that all financial transactions on your account are in order
              before such account can be permanently deleted.
            </li>
            <li className="mb-4">
              Consequently, if you intend to delete your account, scroll to
              “Delete Account”. You would see options as to the reason for you
              to delete your account. Select one of the pre-set options and
              provide more information.
            </li>
            <li className="mb-4">
              After we receive your request, we will check from our record if
              you do not have an unpaid loan with us, an existing savings, or
              money in your wallet.
            </li>
            <li className="mb-4">
              e.If you have any of these (a partially or fully unpaid loan, an
              existing savings, or money in your wallet), we will send you an
              email to liquidate the loan, terminate your savings, or withdraw
              the money in your wallet to your bank account.
            </li>

            <li className="mb-4">
              We will not grant the request to delete the account until the
              above is done. However, where you do not have an unpaid loan,
              existing savings, or any money in your wallet, we will grant your
              request to delete the account and we will send you an email to
              that effect.
            </li>
          </ol>
          {/* Ownership  */}
          <li className="mb-4 font-semibold ">OWNERSHIP</li>

          <ol
            type="a"
            className="font-normal space-y-2 marker:font-bold list-[lower-alpha] ml-4"
          >
            <li className="mb-4">
              The rights in the intellectual properties on our platform reside
              in us, save the intellectual properties of our partners which we
              have used with permission from our partners.
            </li>
            <li className="mb-4">
              You do not obtain any right in our intellectual property as a
              result of the usage of our platform.
            </li>
            <li className="mb-4">
              c.You agree not to, or attempt to, or encourage a third party to
              directly or indirectly decompile, disassemble, modify, reverse
              engineer, reproduce, or otherwise derive the source code or
              underlying structure, ideas, or algorithm of our platform.
            </li>
          </ol>

          {/* external links  */}
          <li className="font-semibold mb-4">EXTERNAL LINKS</li>
          <ol
            type="a"
            className="font-normal space-y-2 marker:font-bold list-[lower-alpha] ml-4"
          >
            <li className="mb-4">
              a.We do not take responsibilities for the content of any external
              links on our platform that take you out of our platform. You are
              required to take precautions in accessing external links, even
              where such links are made available by us.
            </li>
          </ol>
          {/* disclaimer  */}
          <li className="mb-4 font-semibold ">DISCLAIMER</li>

          <ol
            type="a"
            className="font-normal space-y-2 marker:font-bold list-[lower-alpha] ml-4"
          >
            <li className="mb-4">
              We do not claim that our platform shall be error-free,
              uninterrupted, or shall be available at all times.
            </li>
            <li className="mb-4">
              As circumstances may permit, we shall notify you of any downtime
              or scheduled upgrade or maintenance that will hamper access to our
              platform.
            </li>
            <li className="mb-4">
              You shall have the sole responsibility to keep safe all login
              details with which you access our platform. We take no
              responsibility and shall not be liable for any loss, damage, cost,
              or expenses whatsoever that you suffer due to an unauthorised
              access to such login details, except where such unauthorised
              access is attributed to negligence, commission, or omission on our
              part.
            </li>
          </ol>

          {/* exclusion of liability  */}
          <li className="mb-4 font-semibold ">EXCLUSION OF LIABILITY</li>

          <ol
            type="a"
            className="font-normal space-y-2 marker:font-bold list-[lower-alpha] ml-4"
          >
            <li className="mb-4">
              We shall not be liable to you for any breach of these terms where
              such breach is occasioned by or is due to events beyond our
              reasonable control.
            </li>
          </ol>

          {/* LIMITATION OF LIABILITY  */}
          <li className="mb-4 font-semibold ">LIMITATION OF LIABILITY</li>
          <ol
            type="a"
            className="font-normal space-y-2 marker:font-bold list-[lower-alpha] ml-4"
          >
            <li className="mb-4">
              In any event, our total liability to you shall be limited to any
              service fee we have received from you within 12 months prior to
              the claim for such liability.
            </li>
          </ol>
          {/* GOVERNING LAW AND DISPUTE RESOLUTION  */}
          <li className="mb-4 font-semibold ">
            GOVERNING LAW AND DISPUTE RESOLUTION
          </li>
          <ol
            type="a"
            className="font-normal space-y-2 marker:font-bold list-[lower-alpha] ml-4"
          >
            <li className="mb-4">
              These Terms and Conditions shall be governed by the laws of the
              Federal Republic of Nigeria
            </li>
            <li className="mb-4">
              In the events of any dispute arising between us, both parties
              shall make reasonable efforts to resolve such dispute amicably.
            </li>
            <li className="mb-4">
              Where such dispute is not resolve within fifteen (15) business
              days of the notification of the dispute, the dispute may be
              referred to mediation in accordance with the rules and procedures
              of the Lagos Multi-Door Courthouse in Nigeria.
            </li>
            <li className="mb-4">
              Where such dispute remains unresolved through mediation within
              thirty (30) days, the dispute shall finally be referred to a sole
              arbitrator in accordance with the Arbitration and Mediation Act,
              2023, in Nigeria.
            </li>
            <li className="mb-4">
              The sole mediator shall be appointed jointly by the parties within
              seven (7) days, failing which the appointment shall be made by the
              Chartered Institute of Arbitration, UK (Nigerian Branch).
            </li>
            <li className="mb-4">
              The foregoing shall not preclude a party from seeking a temporary
              relief in a court of competent jurisdiction
            </li>
          </ol>
        </ol>
      </ol>

      <p className="mx-4 md:mx-6 mt-6 text-justify">
        These Terms and Conditions were updated in September 2025. Where the
        provisions of these Terms and Conditions contradict any other legal
        document on our platform, such as a Loan Agreement, the provisions of
        that other legal document shall prevail.
      </p>
    </div>
  );
}

export default TermsContent;
